import React from 'react';
import { ArticleCard } from './ArticleCard';
import { PlusButton } from './PlusButton';
import { SectionHeader } from './SectionHeader';
export function FocusSection() {
  return <section className="w-full relative" style={{
    marginTop: '37px'
  }} data-id="element-47">
      {/* FOCUS badge */}
      <SectionHeader label="Focus" data-id="element-48" />

      {/* Background image area */}
      <div className="relative w-full md:h-[472px]" style={{
      marginTop: '-16px',
      paddingBottom: '40px'
    }} data-id="element-49">
        {/* Background image */}
        <img src="https://cdn.magicpatterns.com/uploads/ajb5gEuWJFfXug76Vg9VR5/Rectangle_88.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" style={{
        zIndex: 0
      }} data-id="element-50" />

        {/* Dark overlay */}
        <div className="absolute inset-0" style={{
        background: 'rgba(0, 0, 0, 0.45)',
        zIndex: 1
      }} data-id="element-51" />

        {/* Text content */}
        <div className="relative site-container flex flex-col items-center" style={{
        zIndex: 2,
        paddingTop: '90px'
      }} data-id="element-52">
          {/* SPECIAL REPORT label */}
          <span style={{
          color: '#FFF',
          textAlign: 'left',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '18.75px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
          letterSpacing: '1.875px',
          textTransform: 'uppercase' as const
        }} data-id="element-53">
            Special Report
          </span>

          {/* Title + Description wrapper */}
          <div style={{
          maxWidth: '800px',
          marginTop: '16px'
        }} data-id="element-54">
            <h2 style={{
            color: '#FFF',
            fontFamily: "'League Gothic', Impact, Arial, sans-serif",
            fontSize: '65px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '65px',
            textAlign: 'left'
          }} data-id="element-55">
              The US agencies storming up the World Creative Rankings
            </h2>

            <p style={{
            color: '#FFF',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
            textAlign: 'left',
            marginTop: '16px',
            maxWidth: '700px'
          }} data-id="element-56">
              Special Group, a global independent creative network, was the
              year's biggest climber in North America.
            </p>
          </div>
        </div>
      </div>

      {/* Article cards — overlapping the background */}
      <div className="relative site-container mt-6 md:-mt-[120px]" style={{
      zIndex: 3
    }} data-id="element-57">
        <div className="relative" style={{
        maxWidth: '1040px',
        margin: '0 auto'
      }} data-id="element-58">
          <div className="w-full grid grid-cols-1 md:grid-cols-3" style={{
          gap: '37px'
        }} data-id="element-59">
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/hRPZKQR6yRt5GLBfrT4ZaU/Rectangle_234_(2).jpg" title="Mazda and Disney Are Big Winners at Oscars With Cinematic Ad Takeover" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-60" />
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/4UN4oXhekkHarGk7yK8mC4/Rectangle_235_(2).jpg" title="Mazda and Disney Are Big Winners at Oscars With Cinematic Ad Takeover" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-61" />
            <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/jtqNx4GLuyF4PBUH5utVcG/Rectangle_236_(3).jpg" title="Mazda and Disney Are Big Winners at Oscars With Cinematic Ad Takeover" description="Special Group, a global independent creative network, was the year's biggest climber in North America." category="NEWS" whiteBorder data-id="element-62" />
          </div>
          <div className="absolute -right-3 lg:-right-5 top-[25%] hidden md:block" data-id="element-63">
            <PlusButton size="sm" data-id="element-64" />
          </div>
        </div>
      </div>
    </section>;
}